module.exports = __webpack_public_path__ + "static/media/Background_Pro_blurred.5afb291d.png";